import { ArticleHeading } from '../../ArticlePage/InthisArticle/styled';
import { ClinicHealthContainer } from '../../Clinic/HealthPlan/styled';
import CommunityFilterList from './CommunityFilterList';

export default function CommunityFilter(props) {
  const { filterData, showLoader, setSelectedFilterId, mutate, indexToShow } =
    props;
  return (
    <>
      <ArticleHeading>Filter By Stage</ArticleHeading>
      <ClinicHealthContainer topicListing>
        <CommunityFilterList
          filterData={filterData}
          showLoader={showLoader}
          setSelectedFilterId={setSelectedFilterId}
          mutate={mutate}
          indexToShow={indexToShow}
        />
      </ClinicHealthContainer>
    </>
  );
}
